import { GetterTree } from 'vuex'
import { PointsOfInterest } from './types'
import { RootState } from '../types'

export const getters: GetterTree<PointsOfInterest, RootState> = {
  getPointsOfInterest: state => state.pointsOfInterest,
  getPointsOfInterestFiltered: state => {
    return state.filteredPointsOfInterest.map(point => {
      if (typeof point.hidePoint === 'undefined') {
        point.hidePoint = false
      }
      return point
    })
  },
  getPointsSortedByName(state) {
    return state.filteredPointsOfInterest.sort((poiA, poiB) =>
      poiA.label > poiB.label ? 1 : poiA.label < poiB.label ? -1 : 0
    )
  },
  getPointsOfInterestOnMap: state => state.pointsOfInterestOnMap,
  showPointsOfInterestOnMap: state => state.pointsOfInterestOnMap.length > 0
}
